import {
  IAPIServiceConfigItem,
  IMyFavoriteItem,
  IFavoriteTotalItem,
} from '../../../../model/api-modules';
import MostPopular from '../../../../assets/img/most-popular.svg';
import NewRelease from '../../../../assets/img/new-release.png';
import React, { useState, useEffect } from 'react';
import {
  getGameFavoriteTotalAction,
  getServiceMyFavoriteListAction,
} from '../../../../store/modules/games';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { RecommendLayout } from '../../overview/recommend-layout';
import { SingleServiceBlockComponent } from '../single-service-block';
import { FavoriteButton } from '../favorite-button';
import { IGameURLParams } from '../../../../model';
import { DescriptionModal } from '../description-modal';
import './style.scss';
import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly servicesConfig: ReadonlyArray<IAPIServiceConfigItem>;
  readonly myFavoriteList: ReadonlyArray<IMyFavoriteItem>;
  readonly serviceFavoriteTotal: ReadonlyArray<IFavoriteTotalItem>;
}

export const RecommendService = (props: IProps) => {
  const history = useHistory();
  const commonDispatch = useDispatch<any>();
  const routeParams = useParams<IGameURLParams>();

  const [loading, setLoading] = useState<boolean>(false);
  const [serviceDescriptionModalID, setServiceDescriptionModalID] = useState<
    number | null
  >(null);

  useEffect(() => {
    initialization();
  }, []);

  const initialization = async () => {
    setLoading(true);
    await getServiceMyFavoriteListAction(commonDispatch, routeParams.gameId)();
    await getGameFavoriteTotalAction(commonDispatch)();
    setLoading(false);
  };

  const renderServiceDescriptionModal = () => {
    if (serviceDescriptionModalID !== null) {
      const configItem = props.servicesConfig?.find(
        (item) => item.id === serviceDescriptionModalID
      );
      if (configItem && serviceDescriptionModalID === configItem.id) {
        return (
          <DescriptionModal
            onCancel={() => setServiceDescriptionModalID(null)}
            configItem={configItem}
            favoriteList={props.myFavoriteList}
            favoriteTotalList={props.serviceFavoriteTotal}
          />
        );
      }
    }
    return null;
  };

  const goToRouter = (pathname: string) => {
    history.push(pathname);
  };

  const formatServiceItemData = (
    serviceItems: ReadonlyArray<IAPIServiceConfigItem> | null,
    viewServiceID: ReadonlyArray<number>
  ) => {
    const newData = viewServiceID?.map((serviceID) => {
      const serviceItem = serviceItems?.find(
        (serviceItem) => serviceItem.id === serviceID
      );
      return {
        ...serviceItem,
      };
    });
    return newData as ReadonlyArray<IAPIServiceConfigItem>;
  };

  const getSortedReleaseServiceID = () => {
    return props.servicesConfig
      .slice()
      .sort((a, b) => {
        const releaseSortA = a.ReleaseSort || 0;
        const releaseSortB = b.ReleaseSort || 0;
        return releaseSortA - releaseSortB;
      })
      .map((item) => item.id);
  };

  const renderServiceItems = (
    serviceItems: ReadonlyArray<IAPIServiceConfigItem>
  ) => {
    return serviceItems.map((item) => {
      const favoriteTotalItem = props.serviceFavoriteTotal.find(
        (totalItem) => totalItem.ServiceID === item.id
      );
      if (item.Status === 0) {
        return null;
      }
      return (
        <SingleServiceBlockComponent
          viewType="recommend"
          serviceConfig={item}
          onClick={() => setServiceDescriptionModalID(item.id)}
          renderFavoriteButton={
            <FavoriteButton
              favoriteTotal={favoriteTotalItem?.TotalCount}
              favoriteList={props.myFavoriteList}
              serviceConfig={item}
              showTotal={false}
            />
          }
        />
      );
    });
  };

  const favoriteTotal = [...props.serviceFavoriteTotal];
  const sortedServiceIds = favoriteTotal
    .sort((a, b) => Number(b.TotalCount) - Number(a.TotalCount))
    .map((item) => item.ServiceID);
  const mostPopularServiceItems = formatServiceItemData(
    props.servicesConfig,
    sortedServiceIds
    // props.serviceFavoriteTotal.map((item) => item.ServiceID)
  );
  const sortedReleaseServiceItems = formatServiceItemData(
    props.servicesConfig,
    getSortedReleaseServiceID()
  );

  return (
    <div className="recommend-service">
      <RecommendLayout
        goToRouter={goToRouter}
        icon={MostPopular}
        title={getFormatMessage('most_popular')}
        isLoading={loading}
      >
        {renderServiceItems(mostPopularServiceItems)}
      </RecommendLayout>
      <RecommendLayout
        goToRouter={goToRouter}
        icon={NewRelease}
        title={getFormatMessage('new_release')}
        isLoading={loading}
      >
        {renderServiceItems(sortedReleaseServiceItems)}
      </RecommendLayout>
      {renderServiceDescriptionModal()}
    </div>
  );
};
